module.exports = __webpack_public_path__ + "img/pantalla-7-7.d944f8d7.png";